<template>
  <div
    v-loading="loading"
    class="grid-view"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="main-content">
      <div class="section operations">
        <div class="triggers">
          <div style="display: inline-block;">
            <el-button type="primary" @click="queryJobs()">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
            <el-checkbox v-model="autoRefresh" style="margin: 0 5px;" @change="resetTimer">{{ $t('SeaExport.AutomaticallyRefresh') }}</el-checkbox>
          </div>
        </div>
      </div>
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        class="section grid-wrapper"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
  </div>
</template>

<script>
import LocalStorageUtils from '@/utils/localStorageUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { complexQueryAeJobs } from '@/api/AirExport/airExportJob'

export default {
  name: 'StayUploadPhotoLoading',
  data() {
    return {
      loading: false,
      autoRefresh: LocalStorageUtils.getConfiguration('STAY_UPLOAD_PHOTO_LOADING_AUTO_REFRESH') || false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          children: [
            {
              headerName: this.$t('SeaExport.FlightNo'),
              field: 'voyageFlight',
              width: 110
            }, {
              headerName: this.$t('CargoMsg.Cargo_FlightDate'),
              field: 'etd',
              cellRenderer: params => {
                return ColumnUtils.dateLabelFunc(params.value)
              },
              width: 110
            }, {
              headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
              field: 'jobNo',
              width: 150
            },
            {
              headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
              field: 'warehouseNo',
              width: 150
            }, {
              headerName: this.$t('CargoMsg.Cargo_MblNo'),
              field: 'mbl',
              width: 130,
              cellRenderer: params => {
                return ColumnUtils.mawbNoLabelFun(params.value)
              }
            }
          ]
        }, {
          headerName: this.$t('SeaExport.Actual'),
          children: [
            {
              headerName: this.$t('SeaExport.Piece'),
              field: 'quantityActual',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 0, true)
                return '<i>' + txt + '</i>'
              }
            }, {
              headerName: this.$t('queryJob.heavy'),
              field: 'weightActual',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 1, true)
                return '<i>' + txt + '</i>'
              }
            }, {
              headerName: this.$t('SeaExport.Volume'),
              field: 'cubageActual',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 3, true)
                return '<i>' + txt + '</i>'
              }
            }
          ]
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      timerId: 0 // 定时器ID
    }
  },
  created() {
    this.queryJobs()
  },
  methods: {
    queryJobs(operator = '') {
      const conditions = [
        new AdvancedSearchOption(null, 'job.JOB_STATE', 0).formatObj2Json(),
        new AdvancedSearchOption(null, 'airExportJob.LOADING_TERM', AirExportConstants.TP_STUFFY_TYPE.code, AdvancedSearchConsts.OPERATOR_UNEQUAL.code).formatObj2Json(),
        new AdvancedSearchOption(null, 'stayUploadLoadingPhoto').formatObj2Json(),
        new AdvancedSearchOption(null, 'airExportLoadingNotes.TAKE_PHOTOS', true).formatObj2Json(),
        new AdvancedSearchOption(null, 'businessDocument.UUID', null, AdvancedSearchConsts.OPERATOR_IS_NULL.code).formatObj2Json(),
        new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json()
      ]
      this.loading = true
      complexQueryAeJobs({ conditions, branchId: this.$store.getters.currentOfficeId, useAdmin: true, pageNum: 1, pageSize: 1000 }).then(res => {
        this.rowData = res.data.list
        if (operator !== 'timer') {
          this.resetTimer()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    resetTimer() {
      LocalStorageUtils.setConfiguration('STAY_UPLOAD_PHOTO_LOADING_AUTO_REFRESH', this.autoRefresh)
      this.closeTimer()
      if (this.autoRefresh) {
        this.timerId = setInterval(() => {
          this.queryJobs('timer')
        }, 5 * 60 * 1000)
      }
    },
    closeTimer() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .grid-view .main-content ::v-deep {
  .grid-wrapper {
    .ag-header-group-cell-no-group {
      display: none;
    }
    .ag-header-group-cell-label {
      justify-content: center;
    }
    .ag-theme-balham {
      .ag-row-hover {
        background: #9bddff !important;
      }
    }
  }
}
</style>
